import WebHttpClient from '~src/httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IJobHistoryItemDTO } from './IJobHistory';

export interface IGetJobHistoryForTaskParams {
  readonly taskLuid: string;
  readonly pageNumber: number;
  readonly pageSize: number;
}

export interface IGetJobHistoryForTaskResult extends IGetItemsResult {
  readonly jobs: IJobHistoryItemDTO[];
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly totalCount: number;
}

export class GetJobHistoryForTaskRequest extends Request<IGetJobHistoryForTaskParams, IGetJobHistoryForTaskResult> {
  constructor(params: IGetJobHistoryForTaskParams) {
    super('getJobHistoryForTask', params);
  }
}

export class JobHistoryApi {
  public static getJobHistoryForTask(
    taskLuid: string,
    pageNumber: number,
    pageSize: number,
    showToastOnError: boolean = true
  ): Promise<IGetJobHistoryForTaskResult> {
    const request = new GetJobHistoryForTaskRequest({ taskLuid, pageNumber, pageSize });
    return showToastOnError
      ? WebHttpClientWithErrorToastInstance.sendRequest(request)
      : WebHttpClient.sendRequest(request);
  }
}

